import React from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";

import { GiGearHammer } from "react-icons/gi";
import { PiTreeViewBold, PiHexagonBold } from "react-icons/pi";
import {
  MdOutlineShield,
  MdOutlineMonitorHeart,
  MdTaskAlt,
  MdOutlineBuild,
  MdOutlineTrendingUp,
  MdSync,
} from "react-icons/md";
import {
  LuChartNoAxesCombined,
  LuBookText,
  LuSearchCheck,
  LuBellRing,
  LuFactory,
  LuNotepadText,
  LuPackageCheck,
} from "react-icons/lu";
import { FaLeaf } from "react-icons/fa6";
import { TbArrowBigRightLines, TbDeviceAnalytics } from "react-icons/tb";

import "./PartsServices.css";

import p1Image from "../assets/image/p1.png";
import p2Image from "../assets/image/p2.png";

function PartsServices() {
  const steps = [
    { title: "Standards", icon: <LuBookText />, pos: "left-top" },
    {
      title: "Incoming Inspection",
      icon: <LuSearchCheck />,
      pos: "left-center",
    },
    {
      title: "Problem Identification",
      icon: <LuBellRing />,
      pos: "left-bottom",
    },
    {
      title: "Manufacturer Evaluation",
      icon: <LuFactory />,
      pos: "left-sec-top",
    },
    {
      title: "In-Process Inspection",
      icon: <LuNotepadText />,
      pos: "left-sec-center",
    },
    {
      title: "Root Cause Analysis",
      icon: <TbDeviceAnalytics />,
      pos: "left-sec-bottom",
    },
    {
      title: "Production Monitoring",
      icon: <MdOutlineMonitorHeart />,
      pos: "right-top",
    },
    { title: "Final Inspection", icon: <MdTaskAlt />, pos: "right-center" },
    {
      title: "Corrective Actions",
      icon: <MdOutlineBuild />,
      pos: "right-bottom",
    },
    {
      title: "Audits & Improvement",
      icon: <MdOutlineTrendingUp />,
      pos: "right-sec-top",
    },
    {
      title: "Pre-Shipment Testing",
      icon: <LuPackageCheck />,
      pos: "right-sec-center",
    },
    {
      title: "Implementation & Follow-Up",
      icon: <MdSync />,
      pos: "right-sec-bottom",
    },
  ];
  return (
    <div>
      <Helmet>
        <title>Themed Attraction Parts & Services| Riocube Engineering</title>
        <meta
          name="description"
          content="OEM and custom parts for themed attractions. From mechanical components to electrical systems, we keep your magic running smoothly."
        />
        <meta name="keywords" content="" />
      </Helmet>
      <Header />
      <section
        className="hero-banner-P-1"
        style={{ backgroundImage: `url(${p2Image})` }}
      >
        <div className="overlay-P-1">
          <h1>Authorized Distributor or Integrator</h1>
        </div>
        <img className="ADI" src={require("../assets/image/P1bg.png")} alt="" />
      </section>

      <section
        className="hero-banner-P-2"
        style={{ backgroundImage: `url(${p1Image})` }}
      >
        <div className="overlay-P-2">
          <h1>Customized Parts</h1>

          <div className="control-bar">
            <div className="control-item">
              <div className="control-button">Standard Refinement</div>
              <div className="icon-container hex-group">
                <PiHexagonBold className="hex-icon" />
                <PiTreeViewBold className="tree-icon" />
              </div>
            </div>

            <div className="control-item">
              <div className="control-button">Production Standardization</div>
              <div className="icon-container gear-group">
                <GiGearHammer className="gear-icon" />
                <FaLeaf className="leaf-icon" />
              </div>
            </div>

            <div className="control-item">
              <div className="control-button">Continuous Quality Control</div>
              <div className="icon-container shield-group">
                <MdOutlineShield className="shield-icon" />
                <LuChartNoAxesCombined className="chart-icon" />
              </div>
            </div>
          </div>

          <div className="customers-wrapper">
            <div className="customer-section">
              <h2 className="customer-title">SH Customer</h2>
              <div className="product-map">
                <img
                  src={require("../assets/image/SH_Customer.png")}
                  alt="SH Customer Product Map"
                  className="customer-image"
                />
              </div>
            </div>

            <div className="customer-section">
              <h2 className="customer-title">BJ Customer</h2>
              <div className="product-map">
                <img
                  src={require("../assets/image/BJ_Customer.png")}
                  alt="BJ Customer Product Map"
                  className="customer-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="hero-banner-P-3"
        style={{ backgroundImage: `url(${p2Image})` }}
      >
        <div className="qaqc-screen">
          <div className="qaqc-container">
            <div className="qaqc-header">
              <h1>QA/QC</h1>
            </div>

            <div className="process-map">
              {steps.map((step, index) => (
                <div key={index} className={`step ${step.pos}`}>
                  <div className="step-icon">{step.icon}</div>
                  <div className="step-text">{step.title}</div>
                  {!step.pos.includes("right-sec") && (
                    <div className={`connector "flow-left"`}>
                      <TbArrowBigRightLines className="arrow-icon" />
                      <TbArrowBigRightLines className="arrow-clone" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PartsServices;
